import useSWR from "swr";

import SWR_KEYS from "@/constants/swr-keys";
import { IWorkflow } from "@/interfaces/workflow.interface";
import workflowService from "@/services/workflow.service";
import { ByIdRequestProps, RequestsBaseReturn } from "@/types/requests.types";

export type UseGetWorkflowByIdReturn = RequestsBaseReturn<IWorkflow | null>;

export type UseGetWorkflowByIdProps = ByIdRequestProps;

type UseSwrGetWorkflowByIdParams = [string, number];

const useGetWorkflowById = ({ _id }: UseGetWorkflowByIdProps): UseGetWorkflowByIdReturn => {
  const {
    data = null,
    isValidating: isLoading,
    error,
  } = useSWR<IWorkflow, Error, UseSwrGetWorkflowByIdParams | null>(
    _id ? [SWR_KEYS.getWorkflowById, _id] : null,
    ([, workflowId]) => workflowService.getById(workflowId),
    {
      revalidateOnFocus: false,
    }
  );

  return { data, isLoading, error };
};

export default useGetWorkflowById;
